import useSWR from 'swr'
import { Consent } from '../../types/user'
import GLOBALSTORAGE from '../globalstorage'

export default () => {
	return useSWR<Consent>(GLOBALSTORAGE.CONSENT)
}
